<form [formGroup]="form">
  <bolt-tabset class="button-tabs">
    @for (vehicle of vehicles; track trackVehicles(i, vehicle); let i = $index) {
      <bolt-tablabel
        >{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}
        @if (isVehicleFormInvalid(i)) {
          <bolt-icon
            name="exclamation-circle-filled"
            size="sm"
            color="theme-error"
            class="pl-1"
          ></bolt-icon>
        }</bolt-tablabel>
        <bolt-tabpanel class="vehicle-box">
          <nwx-tasks-vehicles-form
            [index]="i"
            [vehicle]="vehicle"
            [vehicleTasks]="getVehicleSpecificTasks(vehicle)"
            (valueChange)="onValueChange($event)"
            (formReady)="addChildForm($event, i, 'vehicle')"
            [submitted]="submitted"
            ></nwx-tasks-vehicles-form
          ></bolt-tabpanel>
        }
      </bolt-tabset>
    </form>
